import React from "react"
import {Button} from "../../../form";

class ProjectHeaderComponent extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            visible: this.props.row.project.visible,
        }
    }

    render() {
        return (
            <div className={"custom-header-cell project" + (this.props.row.project.visible ? "" : " project-disabled")}>
				<span className="project-title">
                    {this.props.row.isSubProject
                        ? <div className="sub-project-spacer"/>
                        : null
                    }
                    {this.props.row.isBalanced
                        ? null
                        : <span title={this.props.row.project.description}>
						<i className="fa fa-exclamation"/>
						</span>
                    }
                    {this.props.row.title}

				</span>
                <div className="actions">
                    <div className="project-properties">
                        <div className="project-priority">P{this.props.row.project.priority}</div>
                        <div
                            className={"project-fctva " + (this.props.row.project.fctva ? "fctva-ok" : "fctva-ko")}>FCTVA
                        </div>
                    </div>
                    {this.props.row.consulted
                        ? null
                        : <span><button onClick={this._handleClick.bind(this)} title="Modifier le projet"><i
                            className="fa fa-edit"/></button>
						<button onClick={this._handleDeleteClick.bind(this)} title="Supprimer le projet"><i
                            className="fa fa-trash"/></button>
                            {this.state.visible ?
                                <button
                                    onClick={() => {
                                        this._handleShowClick()
                                    }}
                                    title={"Masquer le projet"}>

                                    <i className={"fa fa-eye-slash"}/>

                                </button> :
                                <Button
                                    onClick={() => {
                                        this._handleShowClick()
                                    }}
                                    title={"Afficher le projet"}>

                                    <i className={"fa fa-eye"}/>

                                </Button>
                            }
                    </span>
                    }
                </div>
            </div>
        )
    }

    _handleShowClick() {
        this.setState({visible: !this.state.visible})
        this.props.onToggleProject()
    }

    _handleClick() {
        this.props.onCustomAction("alter_project", {
            project: this.props.row.project,
            theme: this.props.row.theme,
            subtheme: this.props.row.subtheme
        })
    }

    _handleDeleteClick() {
        this.props.onCustomAction("destroy_project", {project: this.props.row.project})
    }

}

export default ProjectHeaderComponent



// WEBPACK FOOTER //
// ./src/component/ppi/ppi-detail/investments/project-header-component.js